import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_NEWS } from '@/modules/news/router';
import { newsService } from '@/services/news';
import { useVuelidate } from '@vuelidate/core';
import { useMixins } from './mixins';

export function useNewsEdit() {
    const router = useAppRouter();

    const { model, validations, fetch } = useMixins();
    const v$ = useVuelidate(validations, model);

    const actions = {
        update: useCrudActions().excuteAndNotify({
            validator: v$,
            request: () => {
                const startTime = model.startTime?.getTime() ?? null;
                const endTime = model.endTime?.getTime() ?? null;

                let target = null;
                if (model.targetType == 0) {
                    target = 'link:' + model.target;
                } else if (model.targetType == 1) {
                    target = 'popup:' + model.target;
                } else if (model.targetType == 2) {
                    target = 'deeplink:' + model.target;
                }

                return newsService.update(
                    model.id,
                    model.name,
                    target,
                    startTime,
                    endTime,
                    model.publishTime.getTime(),
                    model.unpublishTime.getTime(),
                    model.imageFile,
                    model.thumbnailFile
                );
            },
            onSuccess: () => router.push({ name: ROUTE_NAME_NEWS.INDEX })
        })
    };

    return { model, v$, fetch, actions };
}
